import { images } from '../../assets/Images/assetsImages';
import CategoryCard from '../LandingPageComponents/SharedComponents/CategoryCard'

const CategoriesSection = () => {

    const categoryData = [
        { title: "Breakfast", image: images.Category1, link: "/breakfast" },
        { title: "Salads", image: images.Category2, link: "/salads" },
        { title: "Sandwiches", image: images.Category3, link: "/sandwiches" },
        { title: "Savory Pies", image: images.Category4, link: "/savory-pies" },
        { title: "Pasta", image: images.Category5, link: "/pasta" },
        { title: "Mains", image: images.Category6, link: "/mains" },
        { title: "Viennoiserie", image: images.Category7, link: "/viennoiserie" },
        { title: "Danish Pastries", image: images.Category8, link: "/danish-pastries" },
        { title: "Artisanal Bread", image: images.Category9, link: "/artisans" },
        { title: "Pies & Tarts", image: images.Category10, link: "/pies-tarts" },
        { title: "Cakes", image: images.Category11, link: "/cakes" },
        { title: "Cupcakes", image: images.Category12, link: "/cupcakes" },
        { title: "Cookies & Bars", image: images.Category13, link: "/cookies" },
        { title: "Bombolones", image: images.Category14, link: "/bombolones" },
        { title: "Cheesecakes", image: images.Category15, link: "/cheesecakes" },
        { title: "Chilled Desserts", image: images.Category16, link: "/chilled-desserts" },
        { title: "Tres Leches", image: images.Category17, link: "/tres-leches" },
        { title: "Gelato", image: images.Category18, link: "/gelato" },
        { title: "Coffee & Tea", image: images.Category19, link: "/coffee-tea" },
        { title: "Smoothies & Milkshakes", image: images.Category20, link: "/someethies-milkshakes" },
        { title: "Juices & Mocktails", image: images.Category21, link: "/juices-mocktails" },
        { title: "Water & Soft drinks", image: images.Category22, link: "/water-softdrinks" },
      ];

    const ratedProducts = [
        { title: "Blueberry Walnut Tart", image: images.RatedProduct1 },
        { title: "Chicken & Mushroom Pie", image: images.RatedProduct2 },
        { title: "Granola Bowl", image: images.RatedProduct3 },
      ];

  return (
    <section className='w-[100%] h-[100%] flex flex-col'>
        <div className='w-full h-full flex flex-col justify-center items-center xl:py-5'>
            <div className='w-full text-center p-4 flex justify-center items-center my-10'>
                <hr className='w-[30%] h-2 bg-[#e6f3cd] border-0'></hr>
                <h1 className='font-semibold font-playfair text-5xl text-[#41220E] mx-10'>Categories</h1>
                <hr className='w-[30%] h-2 bg-[#e6f3cd] border-0'></hr>
            </div>
            <div className="flex flex-wrap justify-center gap-24 px-8 pb-12"
                style={{ maxWidth: 'calc(100% - 80px)' }}  
                initial={{ y: "15%", opacity: 0 }}
                whileInView={{ y: "0", opacity: 1 }}
                transition={{ duration: 1.5, ease: "easeOut" }}>
                {categoryData.map((category, index) => (
                    <div key={index} className='flex items-center justify-center'>
                        <CategoryCard
                            title={category.title}
                            image={category.image}
                            link={category.link}
                        />
                    </div>
                ))}
            </div>

        </div>
        <div className='w-full h-full flex flex-col justify-center items-center xl:py-5'>
            <div className='w-full text-center p-4 flex justify-center items-center my-10'>
                <hr className='w-[30%] h-2 bg-[#e6f3cd] border-0'></hr>
                <h1 className='font-semibold font-playfair text-5xl text-[#41220E] mx-10'>Most Rated Products</h1>
                <hr className='w-[30%] h-2 bg-[#e6f3cd] border-0'></hr>
            </div>

            <div className="flex flex-wrap justify-center gap-24 px-8 pb-12"
                style={{ maxWidth: 'calc(100% - 80px)' }}  
                initial={{ y: "15%", opacity: 0 }}
                whileInView={{ y: "0", opacity: 1 }}
                transition={{ duration: 1.5, ease: "easeOut" }}>
                {ratedProducts.map((product, index) => (
                    <div key={index} className='flex items-center justify-center'>
                        <CategoryCard
                            title={product.title}
                            image={product.image}
                        />
                    </div>
                ))}
            </div>

        </div>
    </section>
  )
}

export default CategoriesSection
